import axios from './base';

// 归档任务列表
export const archivistList = (data) => {
  return axios.post('/planTask/archiveList', data);
};

// 导出列表全部任务
export const exportTasks = (data) => {
  return axios.post('/planTask/export', data);
};
// 导出单个任务
export const exportTask = (data) => {
  return axios.post('/planTask/exportByTaskId', data);
};

// 查询导出的任务列表
export const getExportTaskList = (params) => {
  return axios.get('/plan/getExportList', {
    params: { ...params },
  });
};
// 下载导出任务时删除key
export const delExportTaskKey = (params) => {
  return axios.get('/plan/delExportKey', {
    params: { ...params },
  });
};

// ----------------------------------关注的问题-------------------------------
export const collectQuestionList = (data) => {
  return axios.post('/planTask/getSurveyFocus', data);
};

export const getQuestionDetail = (params) => {
  return axios.get('/planTask/surveyFocus/getDetail', {
    params: { ...params },
  });
};

// ----------------------------------关注的附件--------------------------------
export const getAttachmentList = (data) => {
  return axios.post('/plan/annexFile', data);
};

// 获取当前计划下所有调查员
export const getOfficerList = (params) => {
  return axios.get('/plan/getOfficerList', {
    params: { ...params },
  });
};

// 获取当前计划下所有调查对象
export const getSubjectList = (params) => {
  return axios.get('/plan/getSubjectList', {
    params: { ...params },
  });
};